export const getIntialValues = (data = {}) => {
  return {
    title: data?.title || "",
    description: data?.description || "",
    cta_label: data?.cta_label || "",
    cta_redirection: data?.cta_redirection || "",

    footer_desc: data?.footer_desc || "",
    social_media: {
      medial_details: data?.social_media?.medial_details?.length ? data.social_media.medial_details : [{ image_url: "", social_url: "", alt_tag: "", }],
    },

    quick_links: {
      heading: data?.quick_links?.heading || "",
      inside_pages: data?.quick_links?.inside_pages?.length ? data.quick_links.inside_pages : [{ page_name: "", page_url: "" }],
    },

    support_and_help: {
      heading: data?.support_and_help?.heading || "",
      inside_pages: data?.support_and_help?.inside_pages?.length ? data.support_and_help.inside_pages : [{ page_title: "", page_redirect_url: "" }],
    },

    subscribe: {
      title: data?.subscribe?.title || "",
      description: data?.subscribe?.description || "",
    },

    skill_india_marquee: {
      prefix_text: data?.skill_india_marquee?.prefix_text || "",
      suffix_text: data?.skill_india_marquee?.suffix_text || "",
      logo_url: data?.skill_india_marquee?.logo_url || "",
      is_visible: data?.skill_india_marquee?.is_visible ?? true,
    },
  };
};

export const generatePayload = (values) => {
  return {
    title: values?.title || "",
    description: values?.description || "",
    cta_label: values?.cta_label || "",
    cta_redirection: values?.cta_redirection || "",

    footer_desc: values?.footer_desc || "",

    social_media: {
      medial_details: values?.social_media?.medial_details?.length ? values.social_media.medial_details : [{ image_url: "", social_url: "", alt_tag: "", }],
    },

    quick_links: {
      heading: values?.quick_links?.heading || "",
      inside_pages: values?.quick_links?.inside_pages?.length ? values.quick_links.inside_pages : [{ page_name: "", page_url: "" }],
    },

    support_and_help: {
      heading: values?.support_and_help?.heading || "",
      inside_pages: values?.support_and_help?.inside_pages?.length
        ? values.support_and_help.inside_pages
        : [{ page_title: "", page_redirect_url: "" }],
    },

    subscribe: {
      title: values?.subscribe?.title || "",
      description: values?.subscribe?.description || "",
    },

    skill_india_marquee: {
      prefix_text: values?.skill_india_marquee?.prefix_text || "",
      suffix_text: values?.skill_india_marquee?.suffix_text || "",
      logo_url: values?.skill_india_marquee?.logo_url || "",
      is_visible: values?.skill_india_marquee?.is_visible ?? true,
    },
  };
};
